import React, { forwardRef } from 'react';

import { Icon } from '@column/column-ui-kit';
import { Button, cn } from '@column/ui';

interface TableFilterTriggerProps extends React.ComponentProps<typeof Button> {
  isActive?: boolean;
  isOpen?: boolean;
}

export const TableFilterTrigger = forwardRef<HTMLButtonElement, TableFilterTriggerProps>(
  ({ isActive, isOpen, className, children, ...props }, ref) => (
    <Button
      ref={ref}
      type="button"
      variant="secondary"
      size="sm"
      className={cn(
        'max-w-80 pr-2.5 [&_svg]:[--icon-color:currentColor]',
        isActive && 'text-primary ring-1 ring-primary',
        className
      )}
      {...props}
    >
      <span className="truncate">{children}</span>
      {isOpen ? <Icon.ChevronUp /> : <Icon.ChevronDown />}
    </Button>
  )
);
TableFilterTrigger.displayName = 'TableFilterTrigger';
